import { VueConstructor } from 'vue';
import { CoreOptions } from '../../index';
import _ from '../../utils';
import ErrorComponent from '../../components/error/error.vue';

export default {
  install: (Vue: VueConstructor, options: CoreOptions) => {
    if (Vue.$version.buildConfiguration !== 'test') {
      Vue.config.errorHandler = (error, vm, info) => {
        try {
          Vue.$log.error(`[${info}] ${error} ${_.component.generateTrace(vm)}`);
        } catch {
          Vue.$log.error(`${error}`);
        }
        const errorVue = new ErrorComponent({ data: () => ({ error, vm, info }) });
        const appEl = _.component.getAppEl()!;
        const mountDiv = document.createElement('div');
      // Create new mounting div at root of app
      appEl!.insertBefore(mountDiv, null);
      errorVue.$mount(mountDiv);
      };
      window.onerror = (event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) => {
        if (error === undefined) {
          error = new Error('Unknown error');
        }
        Vue.config.errorHandler(error, new Vue(), 'global');
      };
    }
  },
};
